import type { TencentModelConfig, InputPayloadType } from './types';
import { tencentModelConfigs } from './config';

/**
 * 获取模型配置
 */
export function getTencentModelConfig(modelId: string): TencentModelConfig {
    const config = tencentModelConfigs[modelId];
    if (!config) {
        throw new Error(`Model ${modelId} not found`);
    }
    return config;
}

/**
 * 获取腾讯云 AKSK 凭证
 */
export function getTencentCredentials(): { secretId: string; secretKey: string } {
    const secretId = process.env.TENCENT_CLOUD_SECRET_ID;
    const secretKey = process.env.TENCENT_CLOUD_SECRET_KEY;
    if (!secretId) {
        throw new Error('Missing TENCENT_CLOUD_SECRET_ID');
    }
    if (!secretKey) {
        throw new Error('Missing TENCENT_CLOUD_SECRET_KEY');
    }
    return { secretId, secretKey };
}

/**
 * 获取点播应用 ID (SubAppId)
 */
export function getTencentSubAppId(): number {
    const subAppId = process.env.TENCENT_VOD_SUB_APP_ID;
    if (!subAppId) {
        throw new Error('Missing TENCENT_VOD_SUB_APP_ID');
    }
    const parsed = Number(subAppId);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        throw new Error('Invalid TENCENT_VOD_SUB_APP_ID');
    }
    return parsed;
}

/**
 * 构建输入参数
 */
export async function buildInputPayloadFromConfig(
    modelId: string,
    params: {
        prompt: string;
        imagePrompt?: string[];
        videoUri?: string;
        videoUris?: string[];
        audioUri?: string;
        audioUris?: string[];
        duration: number;
        aspectRatio?: string;
        quality?: string;
        modelUi?: Record<string, any>;
        providerOptions?: Record<string, Record<string, any>>;
    }
): Promise<InputPayloadType> {
    // 获取服务商配置
    const config = getTencentModelConfig(modelId);

    // 构建输入参数
    const result = await config.buildInput(params);

    return result;
}
